<template>
  <div>
    <div
      v-if="
        (router === 'normal' && $auth.policies['view-head-fee-list'] && !isSubFee) ||
          (router === 'priority' && $auth.policies['view-dedution-list'] && !isSubFee) ||
          (router === 'normal' && $auth.policies['view-arrear-fee-list'] && isSubFee) ||
          (router === 'priority' && $auth.policies['view-refund-fee-list'] && isSubFee)
      "
    >
      <div class="pa-4 d-flex justify-space-between align-center">
        <div>
          <Breadcrumbs
            :headline="$route.meta.title"
            :link="[
              { text: 'Tài chính', href: '/#', disabled: false },
              { text: $route.meta.title, disabled: true }
            ]"
          />
        </div>
        <v-spacer></v-spacer>
        <div class="d-flex align-end">
          <v-btn outlined color="success" @click="exportExcel"> <v-icon left>mdi-file-excel</v-icon> Xuất Excel </v-btn>
          <v-btn
            v-if="
              ($auth.policies['add-new-head-fee'] && router === 'normal' && !isSubFee) ||
                (router === 'priority' && $auth.policies['add-new-dedution'] && !isSubFee) ||
                ($auth.policies['add-new-refund-fee'] && router === 'priority' && isSubFee) ||
                ($auth.policies['add-new-arrear-fee'] && router === 'normal' && isSubFee)
            "
            class="ml-6"
            depressed
            color="primary"
            @click="createDialog = !createDialog"
          >
            <v-icon left>add</v-icon>
            Thêm {{ $route.meta.title }}
          </v-btn>
        </div>
      </div>

      <v-card outlined class="pa-9 mx-4 mb-6 elevation-0">
        <FeeFilter ref="headFeeFilter" :key="router" />
      </v-card>

      <v-card outlined class="mx-4 elevation-0" md>
        <headFeeDataTable :key="router" ref="dataTable" />
      </v-card>

      <headFeeNewDialog
        @addHeadFeeSuccess="addHeadFeeSuccess()"
        :state="createDialog"
        style="margin: 0 20px"
      ></headFeeNewDialog>
    </div>
    <div v-else>
      <Page403 />
    </div>
  </div>
</template>
<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import FeeFilter from '@/modules/tuitionFee/head-fee/headFeeFilter.vue'
import headFeeDataTable from '@/modules/tuitionFee/head-fee/headFeeDataTable.vue'
import headFeeNewDialog from '@/modules/tuitionFee/head-fee/headFeeNewDialog.vue'
import { mapActions, mapState } from 'vuex'
import { textHelpers } from '@/helpers/TextHelper.js'
import utils from '@/plugins/utils'
import Page403 from '@/views/Page403.vue'
export default {
  components: {
    Breadcrumbs,
    FeeFilter,
    headFeeDataTable,
    headFeeNewDialog,
    Page403
  },
  data() {
    return {
      dialog: false,
      createDialog: false
    }
  },
  created() {
    this.setType(this.pathName)
  },
  computed: {
    ...mapState('tuitonFeeHeadFee', ['router', 'searchParams', 'isSubFee']),
    pathName() {
      return this.$route.name
    }
  },
  methods: {
    ...mapActions('tuitonFeeHeadFee', ['fetchHeadFees', 'setType']),
    async exportExcel() {
      this.$loading.active = true
      try {
        let headers = [...this.$refs.dataTable.headers]
        let excelHeader = headers.map(({ text, value }) => ({ text, value }))
        excelHeader = excelHeader.filter(excel => excel.value !== 'action')
        const data = await this.fetchHeadFees({
          type: this.router,
          isSubFee: this.isSubFee,
          _sort: 'createdAt:desc',
          _limit: -1
        })
        const dataParse = JSON.parse(JSON.stringify(data))
        const dataConvert = dataParse.map(item => {
          item.category = textHelpers.getCategory(item.category)
          return item
        })
        utils.exportExcel(dataConvert, excelHeader, `Danh sách ${this.$route.meta.title}`)
      } catch (error) {
        this.$alert.error('Đã có lỗi xảy ra: ' + error)
      } finally {
        this.$loading.active = false
      }
    },
    addHeadFeeSuccess() {
      this.$refs.headFeeFilter.addHeadFeeSuccess()
    }
  },
  watch: {
    pathName() {
      this.setType(this.pathName)
    }
  }
}
</script>
